module.exports = __webpack_public_path__ + "img/zs_1@2x.5f2bce37.png";